import {
    Container,
    FormInput,
    FormLabel,
    Modal,
    ModalBody,
    ModalHeader,
    Spacer,
    useModal,
    Notice,
    Icon,
    Grid,
    NoResults,
} from "@holta/ui";
import { Header } from "./parts/Header";
import { SuppliersTable } from "./parts/SuppliersTable";
import { SuppliersContext, useContextValue, useSuppliersContext } from "./context";
import React from "react";
import { FiltersNotificationBar } from "../../components/FiltersNotificationBar";
import { useSuppliersFilterCount } from "../../hooks/useSuppliersFilterCount";
import { useFilteredSuppliers } from "../../hooks/useFilteredSuppliers";
import { useAutoAnimate } from "../../hooks/useAutoAnimate";
import {clearAllCustomerFilters} from '../../actions/ui';

export const Suppliers = () => {
    const filtersAnimationParent = useAutoAnimate();
    const activeFilterCount = useSuppliersFilterCount();
    const suppliers = useFilteredSuppliers();

    return (
        <SuppliersContext.Provider value={undefined}>
            <Container style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}>
                <div>
                    <Header />
                    <div ref={filtersAnimationParent}>
                        {activeFilterCount > 0 && (
                            <Spacer xs={[0, 2, 2, 2]}>
                                <FiltersNotificationBar filtersCount={activeFilterCount} handleClear={clearAllCustomerFilters} />
                            </Spacer>
                        )}
                    </div>
                </div>
                <div style={{ flex: 1, overflow: "auto" }}>
                    {suppliers.length > 0 ? (
                        <SuppliersTable />
                    ) : (
                        <Spacer xs={[0, 2, 2, 2]}>
                            <NoResults text="No suppliers found." />
                        </Spacer>
                    )}
                </div>

            </Container>
        </SuppliersContext.Provider>
    );
};
